import { serializeCompareParam } from "./compare";
import { type SerializedFrame, type StatFrame, serializeFrame } from "./frame";

// What a unit-level link carries (CONTEXT.md: unit-level link; ADRs 0002, 0010, 0012): the two
// empire-wide levers as the stat frame serialises them, the site-wide Faction Selection as
// factionLinkSearch reads it off the page being left, and the pending compare set. Exactly
// these three — a Loadout and a Level belong to one hull in one place and ride no link (ADR
// 0012), which SerializedFrame already holds by type, so this cannot carry them either.
// Declared once (review 2026-09-08): the roster's row link, the entity page's back link and
// its strikecraft links, and a comparison column's title link each hand-assembled the same
// triple, and the palette composed it a fifth time.
//
// Key order is part of the contract: the router writes search keys in object order, so every
// link this produces reads corruption, tech, faction, compare — the order the five sites wrote.

export interface UnitLinkSearch extends SerializedFrame {
  faction?: string;
  compare: string | undefined;
}

/** The search a unit-level link carries: this frame's two link-riding keys, the selection as
 * the leaving page read it (factionLinkSearch), and these compare ids. */
export function unitLinkSearch(
  frame: StatFrame,
  faction: { faction?: string },
  compareIds: readonly string[],
): UnitLinkSearch {
  return { ...serializeFrame(frame), ...faction, compare: serializeCompareParam(compareIds) };
}
